<div class="home-descr">
  <div class="descr-cont">
    <h2>{{ 'home.title.title' | translate }}</h2>
    <p class="grey">{{ 'home.title.descr' | translate }}</p>
    <div class="img-container">
      <img [src]="'../../../assets/home/mappa_PRIMIS_' + current_lang + '.png'" [title]="'home.title.img_title' | translate">
      <button class="ladini" [routerLink]="['/home/aree/' + geopos_url['Ladini del Comelico']]" [title]="'home.title.ladini' | translate"></button>
      <button class="slo-ita-n" [routerLink]="['/home/aree/' + geopos_url['Sloveni in Italia']]" [title]="'home.title.slo_ita' | translate"></button>
      <button class="slo-ita-s" [routerLink]="['/home/aree/' + geopos_url['Sloveni in Italia']]" [title]="'home.title.slo_ita' | translate"></button>
      <button class="ita-slo" [routerLink]="['/home/aree/' + geopos_url['Italiani in Slovenia']]" [title]="'home.title.ita_slo' | translate"></button>
      <button class="cimbri" [routerLink]="['/home/aree/' + geopos_url['Cimbri']]" [title]="'home.title.cimbri' | translate"></button>
      <button class="friuli" [routerLink]="['/home/aree/' + geopos_url['Friulani in Veneto']]" [title]="'home.title.friuli' | translate"></button>
      <button class="friuli-fvg" [routerLink]="['/home/aree/' + geopos_url['Friulani in Friuli Venezia Giulia']]" [title]="'home.title.friuli-fvg' | translate"></button>
    </div>
  </div>
</div>

<div class="primis-descr">
  <p class="grey">{{'home.descr' | translate}}</p>
</div>
